import { Button, Modal } from "react-bootstrap";
import React, {useContext, useEffect, useState} from "react";
import 'react-medium-image-zoom/dist/styles.css'

import NsModalHeader from "../../../components/modal/NsModalHeader";
import Translate from "../../../components/Translate";
import {FiltersContext} from "../../../context/FiltersContext";


export default function ModalFiltroArchivio({
                                                   show,
                                                   handleClose,
                                                   submitOk,
                                               }) {

    const [modello, setModello] = useState('');
    const [inizioProd, setInizioProd] = useState();
    const [fineProd, setFineProd] = useState();
    const [annoDocDa, setAnnoDocDa] = useState();
    const [annoDocA, setAnnoDocA] = useState();

    const {filtroArchivio, updateFiltroArchivio, initFiltroArchivio} = useContext(FiltersContext);

    const handleSave = async () => {
        updateFiltroArchivio('modello', modello);
        updateFiltroArchivio('inizioProd', inizioProd);
        updateFiltroArchivio('fineProd', fineProd);
        updateFiltroArchivio('annoDocDa', annoDocDa);
        updateFiltroArchivio('annoDocA', annoDocA);

        submitOk();
    };

    useEffect(() => {
        setModello(filtroArchivio['modello']);
        setInizioProd(filtroArchivio['inizioProd']);
        setFineProd(filtroArchivio['fineProd']);
        setAnnoDocDa(filtroArchivio['annoDocDa']);
        setAnnoDocA(filtroArchivio['annoDocA']);
    }, [filtroArchivio]);

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size={"xl"}
        >
            <NsModalHeader title={`Filtri`} />
            <Modal.Body>
                <div className={"row g-3"}>
                    <div className={"col-md-6"}>
                        <label htmlFor="modello" className="form-label">Modello:</label>
                        <input
                            type={"text"}
                            id={"modello"}
                            name={"modello"}
                            className={"form-control"}
                            value={modello}
                            onChange={(ev) => setModello(ev.target.value)}
                        />
                    </div>
                    <div className={"col-md-6"}>
                        <label htmlFor="inizioProd" className="form-label">Anno inizio produzione marca:</label>
                        <input
                            type={"number"}
                            id={"inizioProd"}
                            name={"inizioProd"}
                            className={"form-control"}
                            value={inizioProd}
                            onChange={(ev) => setInizioProd(ev.target.value)}
                        />
                    </div>
                    <div className={"col-md-6"}>
                        <label htmlFor="fineProd" className="form-label">Anno fine produzione marca:</label>
                        <input
                            type={"number"}
                            id={"fineProd"}
                            name={"fineProd"}
                            className={"form-control"}
                            value={fineProd}
                            onChange={(ev) => setFineProd(ev.target.value)}
                        />
                    </div>
                    <div className={"col-md-6"}>
                        <label htmlFor="dataDocDa" className="form-label">Documenti a partire dall'anno:</label>
                        <input
                            type={"number"}
                            id={"annoDocDa"}
                            name={"annoDocDa"}
                            className={"form-control"}
                            value={annoDocDa}
                            onChange={(ev) => setAnnoDocDa(ev.target.value)}
                        />
                    </div>
                    <div className={"col-md-6"}>
                        <label htmlFor="dataDocA" className="form-label">Documenti fino all'anno:</label>
                        <input
                            type={"number"}
                            id={"annoDocA"}
                            name={"annoDocA"}
                            className={"form-control"}
                            value={annoDocA}
                            onChange={(ev) => setAnnoDocA(ev.target.value)}
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    <Translate>Chiudi</Translate>
                </Button>
                <Button variant="secondary" onClick={() => {
                    initFiltroArchivio();

                    setModello('');
                    setInizioProd('');
                    setFineProd('');
                    setAnnoDocDa('');
                    setAnnoDocA('');
                }}>
                    <Translate>Pulisci filtri</Translate>
                </Button>
                <Button variant="primary" onClick={handleSave}>
                    <Translate>Conferma</Translate>
                </Button>
            </Modal.Footer>
        </Modal>
    )
}